"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcComponentBlock = function (props) {
    var customStyle = props.customStyle, center = props.center, children = props.children;
    var defaultBlockStyle = { boxShadow: '0 0 3px 0 rgba(0,0,0,.05)' };
    var componentBlockStyle = __assign(__assign({}, defaultBlockStyle), customStyle);
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "rounded-sm mb-6 border-0", style: componentBlockStyle },
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-6 " + (center ? 'd-flex align-items-center justify-content-center' : undefined) }, children)));
};
exports.AcComponentBlock = AcComponentBlock;
exports.default = AcComponentBlock;
//# sourceMappingURL=AcComponentBlock.js.map